import React from 'react';
import { useNavigate } from 'react-router-dom';

const CanceledPage = () => {
  const navigate = useNavigate();

  return (
    <div className="flex font-display items-center justify-center h-screen">
      <div className="bg-white p-6 rounded-lg shadow-2xl text-center relative">
        <button className="transform flex items-center justify-center w-10 h-10 bg-[#F65757] mx-auto text-[#3E1D9E] font-bold rounded-full">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            stroke="#FFFFFF"
            className="w-10 h-10"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="2"
              d="M12 8v4m0 4h.01"
            />
          </svg>
        </button>
        <div className="mt-4 text-base font-bold">Sorry</div>
        <div className="text-base font-bold">Your payment is unsuccessful</div>
        <button
          className="mt-3 border px-2 py-2 rounded-lg text-sm border-black"
          onClick={() => navigate('/')}
        >
          Try Again
        </button>
      </div>
    </div>
  );
};

export default CanceledPage;
